import React from "react";
import NotFound from "../pages/NotFound";
import AuthLayout from "../components/layout/AuthLayout";
import CpanelDashboard from "../pages/cpanel/pages/dashboard";
import WebsiteFlow from "../pages/website-flow/WebsiteFlow";
import WebsiteFlowLayout from "../components/layout/WebsiteFlowLayout";
import Template from "../pages/cpanel/template";
import CustomerQueries from "../pages/cpanel/pages/customer-queries/CustomerQueries";

// Lazy loaded components
const Signin = React.lazy(() => import("../pages/auth/signin/Signin"));
const Signup = React.lazy(() => import("../pages/auth/signup/Signup"));
const ForgetPassword = React.lazy(() => import("../pages/auth/forget-password/ForgetPassword"));
const ResetPassword = React.lazy(() => import("../pages/auth/reset-password/ResetPassword"));

const getRoutes = (isCompleted, customerContentRoutes = []) => {
  console.log("inside getRoutes isCompleted-------------->", isCompleted);

  const baseRoutes = [
    {
      path: "/",
      title: "Home",
      component: isCompleted ? CpanelDashboard : WebsiteFlow,
      private: true,
      layout: isCompleted ? Template : WebsiteFlowLayout,
    },
    {
      path: "success-payment",
      title: "Success",
      component: WebsiteFlow,
      private: true,
      layout: WebsiteFlowLayout,
    },
    {
      path: "/signup",
      title: "Account Creation",
      component: Signup,
      layout: AuthLayout,
      private: false,
    },
    {
      path: "/signin",
      title: "Account Signin",
      component: Signin,
      layout: AuthLayout,
      private: false,
    },
    {
      path: "/forget-password",
      title: "Forget Password",
      component: ForgetPassword,
      layout: AuthLayout,
      private: false,
    },
    {
      path: "/reset-password",
      title: "Reset Password",
      component: ResetPassword,
      layout: AuthLayout,
      private: false,
    },
    {
      path: "/website-flow",
      title: "Website flow",
      component: WebsiteFlow,
      layout: WebsiteFlowLayout,
      private: true,
    },
    {
      path: "/cpanel",
      title: "C panel",
      component: CpanelDashboard,
      layout: Template,
      private: true,
    },    {
      path: "/customer-queries",
      title: "Customer Queries",
      component: CustomerQueries,
      layout: Template,
      private: true,
    },

  ];

  const hasCustomerContentRoutes = customerContentRoutes.length > 0;
  const hasCustomerRoutes = baseRoutes.length > 0;

  let appRoutes = [...baseRoutes];

  if (isCompleted && hasCustomerContentRoutes) {
    appRoutes = [...appRoutes, ...customerContentRoutes];
  }

  // Decide if NotFound route should be appended
  const shouldCheckRoutes =
    (isCompleted && hasCustomerRoutes && hasCustomerContentRoutes) ||
    (!isCompleted && (hasCustomerRoutes || hasCustomerContentRoutes));

  if (shouldCheckRoutes) {
    appRoutes.push({
      path: "*",
      title: "Not Found",
      component: NotFound,
      layout: null,
    });
  }

  // console.log("Final app routes:", appRoutes);
  return appRoutes;
};

export default getRoutes;
